export class ModalOptions {
  type: string;
  title: string;
  description: string;
  buttonPrimaryLabel?: string;
  buttonSecondaryLabel?: string;
  invertButtons?: boolean;
}
